import { type CrmData } from '@playbooks/core/src/interfaces/ConnectToCrmWidget'
import { ElementWithCodeAndValue } from '@playbooks/core/src/interfaces/ActionCard'

import { processReplacements } from './processReplacements'

function replaceWidgetStaticFields(staticFields: CrmData, elementsWithCode: ElementWithCodeAndValue[]) {
  const staticFieldsKeys = Object.keys(staticFields)

  if (staticFields) {
    for (const key of staticFieldsKeys) {
      if (typeof staticFields[key] === 'string') {
        staticFields[key] = processReplacements(staticFields[key], elementsWithCode)!
      }
    }
  }

  return staticFields
}

export default replaceWidgetStaticFields
